import * as ambassadorWixEventsV1Form from './events-v1-form-forms.http.js';
import * as ambassadorWixEventsV1FormTypes from './events-v1-form-forms.types.js';
import * as ambassadorWixEventsV1FormUniversalTypes from './events-v1-form-forms.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getForm(): __PublicMethodMetaInfo<
  'GET',
  { eventId: string },
  ambassadorWixEventsV1FormUniversalTypes.GetFormRequest,
  ambassadorWixEventsV1FormTypes.GetFormRequest,
  ambassadorWixEventsV1FormUniversalTypes.GetFormResponse,
  ambassadorWixEventsV1FormTypes.GetFormResponse
> {
  const payload = { eventId: ':eventId' } as any;

  const getRequestOptions = ambassadorWixEventsV1Form.getForm(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/events/{eventId}/form',
    pathParams: { eventId: 'eventId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addControl(): __PublicMethodMetaInfo<
  'POST',
  { eventId: string },
  ambassadorWixEventsV1FormUniversalTypes.AddControlRequest,
  ambassadorWixEventsV1FormTypes.AddControlRequest,
  ambassadorWixEventsV1FormUniversalTypes.AddControlResponse,
  ambassadorWixEventsV1FormTypes.AddControlResponse
> {
  const payload = { eventId: ':eventId' } as any;

  const getRequestOptions = ambassadorWixEventsV1Form.addControl(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/events/{eventId}/form/control',
    pathParams: { eventId: 'eventId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateControl(): __PublicMethodMetaInfo<
  'PUT',
  { eventId: string; id: string },
  ambassadorWixEventsV1FormUniversalTypes.UpdateControlRequest,
  ambassadorWixEventsV1FormTypes.UpdateControlRequest,
  ambassadorWixEventsV1FormUniversalTypes.UpdateControlResponse,
  ambassadorWixEventsV1FormTypes.UpdateControlResponse
> {
  const payload = { eventId: ':eventId', id: ':id' } as any;

  const getRequestOptions = ambassadorWixEventsV1Form.updateControl(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/v1/events/{eventId}/form/controls/{id}',
    pathParams: { eventId: 'eventId', id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteControl(): __PublicMethodMetaInfo<
  'DELETE',
  { eventId: string; id: string },
  ambassadorWixEventsV1FormUniversalTypes.DeleteControlRequest,
  ambassadorWixEventsV1FormTypes.DeleteControlRequest,
  ambassadorWixEventsV1FormUniversalTypes.DeleteControlResponse,
  ambassadorWixEventsV1FormTypes.DeleteControlResponse
> {
  const payload = { eventId: ':eventId', id: ':id' } as any;

  const getRequestOptions = ambassadorWixEventsV1Form.deleteControl(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/events/{eventId}/form/controls/{id}',
    pathParams: { eventId: 'eventId', id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateMessages(): __PublicMethodMetaInfo<
  'PATCH',
  { eventId: string },
  ambassadorWixEventsV1FormUniversalTypes.UpdateMessagesRequest,
  ambassadorWixEventsV1FormTypes.UpdateMessagesRequest,
  ambassadorWixEventsV1FormUniversalTypes.UpdateMessagesResponse,
  ambassadorWixEventsV1FormTypes.UpdateMessagesResponse
> {
  const payload = { eventId: ':eventId' } as any;

  const getRequestOptions = ambassadorWixEventsV1Form.updateMessages(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/events/{eventId}/form/messages',
    pathParams: { eventId: 'eventId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function publishDraft(): __PublicMethodMetaInfo<
  'POST',
  { eventId: string },
  ambassadorWixEventsV1FormUniversalTypes.PublishDraftRequest,
  ambassadorWixEventsV1FormTypes.PublishDraftRequest,
  ambassadorWixEventsV1FormUniversalTypes.PublishDraftResponse,
  ambassadorWixEventsV1FormTypes.PublishDraftResponse
> {
  const payload = { eventId: ':eventId' } as any;

  const getRequestOptions = ambassadorWixEventsV1Form.publishDraft(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/events/{eventId}/form/publish',
    pathParams: { eventId: 'eventId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function discardDraft(): __PublicMethodMetaInfo<
  'DELETE',
  { eventId: string },
  ambassadorWixEventsV1FormUniversalTypes.DiscardDraftRequest,
  ambassadorWixEventsV1FormTypes.DiscardDraftRequest,
  ambassadorWixEventsV1FormUniversalTypes.DiscardDraftResponse,
  ambassadorWixEventsV1FormTypes.DiscardDraftResponse
> {
  const payload = { eventId: ':eventId' } as any;

  const getRequestOptions = ambassadorWixEventsV1Form.discardDraft(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/events/{eventId}/form',
    pathParams: { eventId: 'eventId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Form as FormOriginal,
  InputControl as InputControlOriginal,
  InputControlType as InputControlTypeOriginal,
  InputControlTypeWithLiterals as InputControlTypeWithLiteralsOriginal,
  Input as InputOriginal,
  ValueType as ValueTypeOriginal,
  ValueTypeWithLiterals as ValueTypeWithLiteralsOriginal,
  OptionSelection as OptionSelectionOriginal,
  OptionSelectionSelectedOptionOneOf as OptionSelectionSelectedOptionOneOfOriginal,
  Label as LabelOriginal,
  FormMessages as FormMessagesOriginal,
  RsvpFormMessages as RsvpFormMessagesOriginal,
  PositiveResponseConfirmation as PositiveResponseConfirmationOriginal,
  NegativeResponseConfirmation as NegativeResponseConfirmationOriginal,
  Positive as PositiveOriginal,
  Negative as NegativeOriginal,
  CheckoutFormMessages as CheckoutFormMessagesOriginal,
  ResponseConfirmation as ResponseConfirmationOriginal,
  RegistrationClosedMessages as RegistrationClosedMessagesOriginal,
  TicketsUnavailableMessages as TicketsUnavailableMessagesOriginal,
  FormInputControlAdded as FormInputControlAddedOriginal,
  FormInputControlUpdated as FormInputControlUpdatedOriginal,
  FormInputControlDeleted as FormInputControlDeletedOriginal,
  GetFormRequest as GetFormRequestOriginal,
  RequestedFields as RequestedFieldsOriginal,
  RequestedFieldsWithLiterals as RequestedFieldsWithLiteralsOriginal,
  GetFormResponse as GetFormResponseOriginal,
  AddControlRequest as AddControlRequestOriginal,
  AddControlRequestControlOneOf as AddControlRequestControlOneOfOriginal,
  PhoneControl as PhoneControlOriginal,
  AddressControl as AddressControlOriginal,
  AddressControlLabels as AddressControlLabelsOriginal,
  DateControl as DateControlOriginal,
  AdditionalGuestsControl as AdditionalGuestsControlOriginal,
  Labels as LabelsOriginal,
  DropdownControl as DropdownControlOriginal,
  RadioButtonControl as RadioButtonControlOriginal,
  CheckboxControl as CheckboxControlOriginal,
  TextControl as TextControlOriginal,
  AddControlResponse as AddControlResponseOriginal,
  UpdateControlRequest as UpdateControlRequestOriginal,
  UpdateControlRequestControlOneOf as UpdateControlRequestControlOneOfOriginal,
  NameControl as NameControlOriginal,
  NameControlLabels as NameControlLabelsOriginal,
  EmailControl as EmailControlOriginal,
  UpdateControlResponse as UpdateControlResponseOriginal,
  DeleteControlRequest as DeleteControlRequestOriginal,
  DeleteControlResponse as DeleteControlResponseOriginal,
  UpdateMessagesRequest as UpdateMessagesRequestOriginal,
  UpdateMessagesResponse as UpdateMessagesResponseOriginal,
  PublishDraftRequest as PublishDraftRequestOriginal,
  PublishDraftResponse as PublishDraftResponseOriginal,
  EventUpdated as EventUpdatedOriginal,
  Location as LocationOriginal,
  MapCoordinates as MapCoordinatesOriginal,
  LocationType as LocationTypeOriginal,
  LocationTypeWithLiterals as LocationTypeWithLiteralsOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  SubdivisionType as SubdivisionTypeOriginal,
  SubdivisionTypeWithLiterals as SubdivisionTypeWithLiteralsOriginal,
  ScheduleConfig as ScheduleConfigOriginal,
  Recurrences as RecurrencesOriginal,
  Occurrence as OccurrenceOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  Event as EventOriginal,
  Scheduling as SchedulingOriginal,
  Image as ImageOriginal,
  EventStatus as EventStatusOriginal,
  EventStatusWithLiterals as EventStatusWithLiteralsOriginal,
  Registration as RegistrationOriginal,
  EventType as EventTypeOriginal,
  EventTypeWithLiterals as EventTypeWithLiteralsOriginal,
  RegistrationStatus as RegistrationStatusOriginal,
  RegistrationStatusWithLiterals as RegistrationStatusWithLiteralsOriginal,
  RsvpCollection as RsvpCollectionOriginal,
  RsvpCollectionConfig as RsvpCollectionConfigOriginal,
  RsvpStatusOptions as RsvpStatusOptionsOriginal,
  RsvpStatusOptionsWithLiterals as RsvpStatusOptionsWithLiteralsOriginal,
  RsvpConfirmationMessages as RsvpConfirmationMessagesOriginal,
  RsvpConfirmationMessagesPositiveResponseConfirmation as RsvpConfirmationMessagesPositiveResponseConfirmationOriginal,
  RsvpConfirmationMessagesNegativeResponseConfirmation as RsvpConfirmationMessagesNegativeResponseConfirmationOriginal,
  Ticketing as TicketingOriginal,
  TicketingConfig as TicketingConfigOriginal,
  TaxConfig as TaxConfigOriginal,
  TaxType as TaxTypeOriginal,
  TaxTypeWithLiterals as TaxTypeWithLiteralsOriginal,
  TicketsConfirmationMessages as TicketsConfirmationMessagesOriginal,
  CheckoutType as CheckoutTypeOriginal,
  CheckoutTypeWithLiterals as CheckoutTypeWithLiteralsOriginal,
  Money as MoneyOriginal,
  ExternalEvent as ExternalEventOriginal,
  VisitorType as VisitorTypeOriginal,
  VisitorTypeWithLiterals as VisitorTypeWithLiteralsOriginal,
  CalendarLinks as CalendarLinksOriginal,
  SiteUrl as SiteUrlOriginal,
  Dashboard as DashboardOriginal,
  RsvpSummary as RsvpSummaryOriginal,
  TicketingSummary as TicketingSummaryOriginal,
  GuestListConfig as GuestListConfigOriginal,
  Feed as FeedOriginal,
  OnlineConferencing as OnlineConferencingOriginal,
  OnlineConferencingConfig as OnlineConferencingConfigOriginal,
  ConferenceType as ConferenceTypeOriginal,
  ConferenceTypeWithLiterals as ConferenceTypeWithLiteralsOriginal,
  OnlineConferencingSession as OnlineConferencingSessionOriginal,
  SeoSettings as SeoSettingsOriginal,
  SeoSchema as SeoSchemaOriginal,
  Keyword as KeywordOriginal,
  Tag as TagOriginal,
  Settings as SettingsOriginal,
  Agenda as AgendaOriginal,
  Category as CategoryOriginal,
  CategoryCounts as CategoryCountsOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  EventDisplaySettings as EventDisplaySettingsOriginal,
  LabellingSettings as LabellingSettingsOriginal,
  RichContent as RichContentOriginal,
  Node as NodeOriginal,
  NodeDataOneOf as NodeDataOneOfOriginal,
  NodeType as NodeTypeOriginal,
  NodeTypeWithLiterals as NodeTypeWithLiteralsOriginal,
  NodeStyle as NodeStyleOriginal,
  ButtonData as ButtonDataOriginal,
  BackgroundType as BackgroundTypeOriginal,
  BackgroundTypeWithLiterals as BackgroundTypeWithLiteralsOriginal,
  Gradient as GradientOriginal,
  GradientType as GradientTypeOriginal,
  GradientTypeWithLiterals as GradientTypeWithLiteralsOriginal,
  Stop as StopOriginal,
  Border as BorderOriginal,
  Colors as ColorsOriginal,
  Background as BackgroundOriginal,
  PluginContainerData as PluginContainerDataOriginal,
  WidthType as WidthTypeOriginal,
  WidthTypeWithLiterals as WidthTypeWithLiteralsOriginal,
  PluginContainerDataWidth as PluginContainerDataWidthOriginal,
  PluginContainerDataWidthDataOneOf as PluginContainerDataWidthDataOneOfOriginal,
  PluginContainerDataAlignment as PluginContainerDataAlignmentOriginal,
  PluginContainerDataAlignmentWithLiterals as PluginContainerDataAlignmentWithLiteralsOriginal,
  Spoiler as SpoilerOriginal,
  Height as HeightOriginal,
  ButtonDataType as ButtonDataTypeOriginal,
  ButtonDataTypeWithLiterals as ButtonDataTypeWithLiteralsOriginal,
  Styles as StylesOriginal,
  Link as LinkOriginal,
  LinkDataOneOf as LinkDataOneOfOriginal,
  Target as TargetOriginal,
  TargetWithLiterals as TargetWithLiteralsOriginal,
  Rel as RelOriginal,
  CodeBlockData as CodeBlockDataOriginal,
  TextStyle as TextStyleOriginal,
  TextAlignment as TextAlignmentOriginal,
  TextAlignmentWithLiterals as TextAlignmentWithLiteralsOriginal,
  DividerData as DividerDataOriginal,
  LineStyle as LineStyleOriginal,
  LineStyleWithLiterals as LineStyleWithLiteralsOriginal,
  Width as WidthOriginal,
  WidthWithLiterals as WidthWithLiteralsOriginal,
  DividerDataAlignment as DividerDataAlignmentOriginal,
  DividerDataAlignmentWithLiterals as DividerDataAlignmentWithLiteralsOriginal,
  FileData as FileDataOriginal,
  ViewMode as ViewModeOriginal,
  ViewModeWithLiterals as ViewModeWithLiteralsOriginal,
  FileSource as FileSourceOriginal,
  FileSourceDataOneOf as FileSourceDataOneOfOriginal,
  PDFSettings as PDFSettingsOriginal,
  GalleryData as GalleryDataOriginal,
  Media as MediaOriginal,
  ItemImage as ItemImageOriginal,
  Video as VideoOriginal,
  Item as ItemOriginal,
  ItemDataOneOf as ItemDataOneOfOriginal,
  GalleryOptions as GalleryOptionsOriginal,
  LayoutType as LayoutTypeOriginal,
  LayoutTypeWithLiterals as LayoutTypeWithLiteralsOriginal,
  Orientation as OrientationOriginal,
  OrientationWithLiterals as OrientationWithLiteralsOriginal,
  Crop as CropOriginal,
  CropWithLiterals as CropWithLiteralsOriginal,
  ThumbnailsAlignment as ThumbnailsAlignmentOriginal,
  ThumbnailsAlignmentWithLiterals as ThumbnailsAlignmentWithLiteralsOriginal,
  GalleryOptionsLayout as GalleryOptionsLayoutOriginal,
  ItemStyle as ItemStyleOriginal,
  Thumbnails as ThumbnailsOriginal,
  GIFData as GIFDataOriginal,
  GIF as GIFOriginal,
  GIFType as GIFTypeOriginal,
  GIFTypeWithLiterals as GIFTypeWithLiteralsOriginal,
  HeadingData as HeadingDataOriginal,
  HTMLData as HTMLDataOriginal,
  HTMLDataDataOneOf as HTMLDataDataOneOfOriginal,
  Source as SourceOriginal,
  SourceWithLiterals as SourceWithLiteralsOriginal,
  ImageData as ImageDataOriginal,
  StylesBorder as StylesBorderOriginal,
  ImageDataStyles as ImageDataStylesOriginal,
  LinkPreviewData as LinkPreviewDataOriginal,
  StylesPosition as StylesPositionOriginal,
  StylesPositionWithLiterals as StylesPositionWithLiteralsOriginal,
  LinkPreviewDataStyles as LinkPreviewDataStylesOriginal,
  MapData as MapDataOriginal,
  MapSettings as MapSettingsOriginal,
  MapType as MapTypeOriginal,
  MapTypeWithLiterals as MapTypeWithLiteralsOriginal,
  ParagraphData as ParagraphDataOriginal,
  PollData as PollDataOriginal,
  ViewRole as ViewRoleOriginal,
  ViewRoleWithLiterals as ViewRoleWithLiteralsOriginal,
  VoteRole as VoteRoleOriginal,
  VoteRoleWithLiterals as VoteRoleWithLiteralsOriginal,
  Permissions as PermissionsOriginal,
  Option as OptionOriginal,
  PollSettings as PollSettingsOriginal,
  PollLayoutType as PollLayoutTypeOriginal,
  PollLayoutTypeWithLiterals as PollLayoutTypeWithLiteralsOriginal,
  PollLayoutDirection as PollLayoutDirectionOriginal,
  PollLayoutDirectionWithLiterals as PollLayoutDirectionWithLiteralsOriginal,
  PollLayout as PollLayoutOriginal,
  OptionLayout as OptionLayoutOriginal,
  PollDesignBackgroundType as PollDesignBackgroundTypeOriginal,
  PollDesignBackgroundTypeWithLiterals as PollDesignBackgroundTypeWithLiteralsOriginal,
  BackgroundGradient as BackgroundGradientOriginal,
  PollDesignBackground as PollDesignBackgroundOriginal,
  PollDesignBackgroundBackgroundOneOf as PollDesignBackgroundBackgroundOneOfOriginal,
  PollDesign as PollDesignOriginal,
  OptionDesign as OptionDesignOriginal,
  Poll as PollOriginal,
  PollDataLayout as PollDataLayoutOriginal,
  Design as DesignOriginal,
  TextData as TextDataOriginal,
  Decoration as DecorationOriginal,
  DecorationDataOneOf as DecorationDataOneOfOriginal,
  DecorationType as DecorationTypeOriginal,
  DecorationTypeWithLiterals as DecorationTypeWithLiteralsOriginal,
  AnchorData as AnchorDataOriginal,
  ColorData as ColorDataOriginal,
  LinkData as LinkDataOriginal,
  MentionData as MentionDataOriginal,
  FontSizeData as FontSizeDataOriginal,
  FontType as FontTypeOriginal,
  FontTypeWithLiterals as FontTypeWithLiteralsOriginal,
  SpoilerData as SpoilerDataOriginal,
  FontFamilyData as FontFamilyDataOriginal,
  AppEmbedData as AppEmbedDataOriginal,
  AppEmbedDataAppDataOneOf as AppEmbedDataAppDataOneOfOriginal,
  Position as PositionOriginal,
  PositionWithLiterals as PositionWithLiteralsOriginal,
  AspectRatio as AspectRatioOriginal,
  AspectRatioWithLiterals as AspectRatioWithLiteralsOriginal,
  Resizing as ResizingOriginal,
  ResizingWithLiterals as ResizingWithLiteralsOriginal,
  Placement as PlacementOriginal,
  PlacementWithLiterals as PlacementWithLiteralsOriginal,
  CardStylesType as CardStylesTypeOriginal,
  CardStylesTypeWithLiterals as CardStylesTypeWithLiteralsOriginal,
  Alignment as AlignmentOriginal,
  AlignmentWithLiterals as AlignmentWithLiteralsOriginal,
  Layout as LayoutOriginal,
  LayoutWithLiterals as LayoutWithLiteralsOriginal,
  AppType as AppTypeOriginal,
  AppTypeWithLiterals as AppTypeWithLiteralsOriginal,
  BookingData as BookingDataOriginal,
  EventData as EventDataOriginal,
  ButtonStyles as ButtonStylesOriginal,
  ImageStyles as ImageStylesOriginal,
  RibbonStyles as RibbonStylesOriginal,
  CardStyles as CardStylesOriginal,
  PricingData as PricingDataOriginal,
  VideoData as VideoDataOriginal,
  PlaybackOptions as PlaybackOptionsOriginal,
  EmbedData as EmbedDataOriginal,
  Oembed as OembedOriginal,
  CollapsibleListData as CollapsibleListDataOriginal,
  InitialExpandedItems as InitialExpandedItemsOriginal,
  InitialExpandedItemsWithLiterals as InitialExpandedItemsWithLiteralsOriginal,
  Direction as DirectionOriginal,
  DirectionWithLiterals as DirectionWithLiteralsOriginal,
  TableData as TableDataOriginal,
  Dimensions as DimensionsOriginal,
  TableCellData as TableCellDataOriginal,
  VerticalAlignment as VerticalAlignmentOriginal,
  VerticalAlignmentWithLiterals as VerticalAlignmentWithLiteralsOriginal,
  CellStyle as CellStyleOriginal,
  BorderColors as BorderColorsOriginal,
  BorderWidths as BorderWidthsOriginal,
  NullValue as NullValueOriginal,
  NullValueWithLiterals as NullValueWithLiteralsOriginal,
  ListValue as ListValueOriginal,
  AudioData as AudioDataOriginal,
  OrderedListData as OrderedListDataOriginal,
  BulletedListData as BulletedListDataOriginal,
  BlockquoteData as BlockquoteDataOriginal,
  CaptionData as CaptionDataOriginal,
  LayoutData as LayoutDataOriginal,
  ImageScalingScaling as ImageScalingScalingOriginal,
  ImageScalingScalingWithLiterals as ImageScalingScalingWithLiteralsOriginal,
  ImagePosition as ImagePositionOriginal,
  ImagePositionWithLiterals as ImagePositionWithLiteralsOriginal,
  Origin as OriginOriginal,
  OriginWithLiterals as OriginWithLiteralsOriginal,
  LayoutDataBackgroundType as LayoutDataBackgroundTypeOriginal,
  LayoutDataBackgroundTypeWithLiterals as LayoutDataBackgroundTypeWithLiteralsOriginal,
  BackdropType as BackdropTypeOriginal,
  BackdropTypeWithLiterals as BackdropTypeWithLiteralsOriginal,
  LayoutDataBackgroundImage as LayoutDataBackgroundImageOriginal,
  VerticalAlignmentAlignment as VerticalAlignmentAlignmentOriginal,
  VerticalAlignmentAlignmentWithLiterals as VerticalAlignmentAlignmentWithLiteralsOriginal,
  ResponsivenessBehaviour as ResponsivenessBehaviourOriginal,
  ResponsivenessBehaviourWithLiterals as ResponsivenessBehaviourWithLiteralsOriginal,
  DesignTarget as DesignTargetOriginal,
  DesignTargetWithLiterals as DesignTargetWithLiteralsOriginal,
  Banner as BannerOriginal,
  LayoutDataBackground as LayoutDataBackgroundOriginal,
  Backdrop as BackdropOriginal,
  LayoutCellData as LayoutCellDataOriginal,
  ShapeData as ShapeDataOriginal,
  ShapeDataStyles as ShapeDataStylesOriginal,
  CardData as CardDataOriginal,
  Scaling as ScalingOriginal,
  ScalingWithLiterals as ScalingWithLiteralsOriginal,
  ImagePositionPosition as ImagePositionPositionOriginal,
  ImagePositionPositionWithLiterals as ImagePositionPositionWithLiteralsOriginal,
  CardDataBackgroundType as CardDataBackgroundTypeOriginal,
  CardDataBackgroundTypeWithLiterals as CardDataBackgroundTypeWithLiteralsOriginal,
  CardDataBackground as CardDataBackgroundOriginal,
  BackgroundImage as BackgroundImageOriginal,
  TocData as TocDataOriginal,
  ListStyle as ListStyleOriginal,
  ListStyleWithLiterals as ListStyleWithLiteralsOriginal,
  Indentation as IndentationOriginal,
  IndentationWithLiterals as IndentationWithLiteralsOriginal,
  SmartBlockData as SmartBlockDataOriginal,
  SmartBlockDataType as SmartBlockDataTypeOriginal,
  SmartBlockDataTypeWithLiterals as SmartBlockDataTypeWithLiteralsOriginal,
  ColumnSize as ColumnSizeOriginal,
  ColumnSizeWithLiterals as ColumnSizeWithLiteralsOriginal,
  SmartBlockCellData as SmartBlockCellDataOriginal,
  Metadata as MetadataOriginal,
  DocumentStyle as DocumentStyleOriginal,
  TextNodeStyle as TextNodeStyleOriginal,
  Badge as BadgeOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  DiscardDraftRequest as DiscardDraftRequestOriginal,
  DiscardDraftResponse as DiscardDraftResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  AddControlApplicationErrors as AddControlApplicationErrorsOriginal,
  UpdateControlApplicationErrors as UpdateControlApplicationErrorsOriginal,
  DeleteControlApplicationErrors as DeleteControlApplicationErrorsOriginal,
} from './events-v1-form-forms.types.js';
